var _defs, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _g2, _rect11, _g3, _rect12, _g4, _g5, _rect13, _g6, _rect14, _g7, _g8, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _g9, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _g10, _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _rect30, _path4, _path5, _rect31, _rect32, _rect33, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e8f68bdd-4984-4f2e-95b7-7fc8ec281257",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 918.14,
    height: 765.54,
    viewBox: "0 0 918.14 765.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "27aa7b70-b106-4a00-be67-693c8380e41d",
    x1: 397.74,
    y1: 717.25,
    x2: 397.74,
    y2: 86.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "46a816da-c484-41ec-8a6f-fbf14454d910",
    x1: 288.88,
    y1: 378.44,
    x2: 288.88,
    y2: 209.65,
    xlinkHref: "#27aa7b70-b106-4a00-be67-693c8380e41d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "32b634d8-28f1-48d9-a868-f602a2cad942",
    x1: 288.88,
    y1: 328.29,
    x2: 288.88,
    y2: 223.1,
    xlinkHref: "#27aa7b70-b106-4a00-be67-693c8380e41d"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "7a4c6aff-0be0-461b-a111-b3ae1b8fbf73",
    transform: "translate(-140.93 -67.23)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "8cc91f6d-19b0-43cc-9c18-2faa83ac34ba",
    "data-name": "<Rectangle>",
    x: 354.51,
    y: 291.55,
    width: 150.6,
    height: 101.52,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "38f1cb81-8fac-4205-a0ff-a33ac00d354c",
    x1: 288.88,
    y1: 594.94,
    x2: 288.88,
    y2: 426.14,
    xlinkHref: "#27aa7b70-b106-4a00-be67-693c8380e41d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6fc01aaf-135e-403e-a209-43b2a4fe59f1",
    x1: 288.88,
    y1: 544.79,
    x2: 288.88,
    y2: 439.6,
    xlinkHref: "#27aa7b70-b106-4a00-be67-693c8380e41d"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "79ce363a-d134-40e4-9f82-b96d04a36978",
    transform: "translate(-140.93 -67.23)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "5b44e697-61fe-43bd-9a58-5f3e41301748",
    "data-name": "<Rectangle>",
    x: 354.51,
    y: 508.05,
    width: 150.6,
    height: 101.52,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "54803c44-522d-4b9e-9a34-f1f7b43e8483",
    x1: 671.57,
    y1: 760.34,
    x2: 671.57,
    y2: 129.2,
    gradientTransform: "translate(1109.43 -194.1) rotate(90)",
    xlinkHref: "#27aa7b70-b106-4a00-be67-693c8380e41d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "089a6a47-adaa-499b-aefb-cd6464b62fb8",
    x1: 670.96,
    y1: 553.63,
    x2: 670.96,
    y2: 387.28,
    gradientTransform: "translate(1129.51 -168.41) rotate(90)",
    xlinkHref: "#27aa7b70-b106-4a00-be67-693c8380e41d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fd8d88e0-7826-450d-9e0b-001d1be709c2",
    x1: 637.66,
    y1: 754.12,
    x2: 637.66,
    y2: 601.05,
    xlinkHref: "#27aa7b70-b106-4a00-be67-693c8380e41d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8d1793c5-b76e-44e2-a52e-569460402331",
    x1: 778.37,
    y1: 673.86,
    x2: 778.37,
    y2: 569.13,
    xlinkHref: "#27aa7b70-b106-4a00-be67-693c8380e41d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "4745700d-8097-45ff-9f71-625443fc4ad8",
    x1: 778.37,
    y1: 774.41,
    x2: 778.37,
    y2: 713.66,
    xlinkHref: "#27aa7b70-b106-4a00-be67-693c8380e41d"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "secure data") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.9,
    y: 86.11,
    width: 469.69,
    height: 631.14,
    fill: "url(#27aa7b70-b106-4a00-be67-693c8380e41d)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 169.02,
    y: 94.67,
    width: 455.01,
    height: 609.12,
    fill: "#f2f2f2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 204.49,
    y: 120.36,
    width: 156.56,
    height: 4.89,
    fill: "#e0e0e0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 204.49,
    y: 142.37,
    width: 156.56,
    height: 4.89,
    fill: "#01bf71",
    opacity: 0.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 384.29,
    y: 120.36,
    width: 156.56,
    height: 4.89,
    fill: "#e0e0e0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 408.75,
    y: 259.8,
    width: 156.56,
    height: 4.89,
    fill: "#e0e0e0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 412.42,
    y: 273.25,
    width: 156.56,
    height: 4.89,
    fill: "#e0e0e0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 419.76,
    y: 286.7,
    width: 156.56,
    height: 4.89,
    fill: "#e0e0e0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 408.75,
    y: 476.29,
    width: 156.56,
    height: 4.89,
    fill: "#e0e0e0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 412.42,
    y: 489.75,
    width: 156.56,
    height: 4.89,
    fill: "#e0e0e0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 419.76,
    y: 503.2,
    width: 156.56,
    height: 4.89,
    fill: "#e0e0e0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 205.71,
    y: 209.65,
    width: 166.35,
    height: 168.79,
    fill: "url(#46a816da-c484-41ec-8a6f-fbf14454d910)"
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 206.76,
    y: 213.32,
    width: 163.72,
    height: 161.45,
    fill: "#f5f5f5"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.53,
    y: 223.1,
    width: 152.7,
    height: 105.19,
    fill: "url(#32b634d8-28f1-48d9-a868-f602a2cad942)"
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "689f37f3-cc41-448d-b172-63ec123bc985",
    "data-name": "<Rectangle>",
    x: 213.58,
    y: 224.32,
    width: 150.6,
    height: 101.52,
    fill: "#fff"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7a4c6aff-0be0-461b-a111-b3ae1b8fbf73)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "200.82 322.18 238.74 263.46 254.64 289.15 288.88 253.68 318.24 289.15 343.93 236.56 409.98 341.75 195.93 334.41 200.82 322.18",
    fill: "#01bf71",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.17,
    cy: 239,
    r: 11.01,
    fill: "#01bf71",
    opacity: 0.4
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 205.71,
    y: 426.14,
    width: 166.35,
    height: 168.79,
    fill: "url(#38f1cb81-8fac-4205-a0ff-a33ac00d354c)"
  }))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 206.76,
    y: 429.81,
    width: 163.72,
    height: 161.45,
    fill: "#f5f5f5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.53,
    y: 439.6,
    width: 152.7,
    height: 105.19,
    fill: "url(#6fc01aaf-135e-403e-a209-43b2a4fe59f1)"
  }))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "b429ac3a-f8a8-4171-bcce-5b6c002c0714",
    "data-name": "<Rectangle>",
    x: 213.58,
    y: 440.82,
    width: 150.6,
    height: 101.52,
    fill: "#fff"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#79ce363a-d134-40e4-9f82-b96d04a36978)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "200.82 538.67 238.74 479.96 254.64 505.65 288.88 470.18 318.24 505.65 343.93 453.05 409.98 558.24 195.93 550.9 200.82 538.67",
    fill: "#bdbdbd",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.17,
    cy: 455.5,
    r: 11.01,
    fill: "#bdbdbd",
    opacity: 0.4
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 349.09,
    y: 242.63,
    width: 631.14,
    height: 469.69,
    transform: "translate(-74.16 969.06) rotate(-78.76)",
    fill: "url(#54803c44-522d-4b9e-9a34-f1f7b43e8483)"
  }))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 359.37,
    y: 247.33,
    width: 609.12,
    height: 455.01,
    transform: "translate(-72.16 966.22) rotate(-78.76)",
    fill: "#fff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 523.5,
    y: 197.22,
    width: 322.91,
    height: 4.89,
    transform: "translate(-88.86 -196.94) rotate(11.24)",
    fill: "#e0e0e0"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 433.36,
    y: 650.7,
    width: 322.91,
    height: 4.89,
    transform: "translate(-2.18 -170.66) rotate(11.24)",
    fill: "#e0e0e0"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 428.58,
    y: 671.14,
    width: 249.52,
    height: 4.89,
    transform: "translate(1.01 -162.18) rotate(11.24)",
    fill: "#e0e0e0"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 424.6,
    y: 683.47,
    width: 92.96,
    height: 4.89,
    transform: "translate(1.84 -145.91) rotate(11.24)",
    fill: "#01bf71",
    opacity: 0.7
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 519.57,
    y: 209.08,
    width: 161.45,
    height: 4.89,
    transform: "translate(-88.17 -180.2) rotate(11.24)",
    fill: "#01bf71",
    opacity: 0.7
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 512.84,
    y: 249.31,
    width: 291.11,
    height: 4.89,
    transform: "translate(-79.21 -190.76) rotate(11.24)",
    fill: "#e0e0e0"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 509.47,
    y: 255.44,
    width: 70.94,
    height: 4.89,
    transform: "translate(-80.19 -168.52) rotate(11.24)",
    fill: "#3ad29f",
    opacity: 0.7
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 501.56,
    y: 307.59,
    width: 322.91,
    height: 4.89,
    transform: "translate(-67.76 -190.54) rotate(11.24)",
    fill: "#e0e0e0"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 575.87,
    y: 357.6,
    width: 166.35,
    height: 289.88,
    transform: "translate(-103.27 983.74) rotate(-78.76)",
    fill: "url(#089a6a47-adaa-499b-aefb-cd6464b62fb8)"
  }))), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 516.06,
    y: 420.61,
    width: 286.22,
    height: 162.68,
    transform: "translate(-30.42 -186.11) rotate(11.24)",
    fill: "#fff"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 496.08,
    y: 335.18,
    width: 322.91,
    height: 4.89,
    transform: "translate(-62.49 -188.94) rotate(11.24)",
    fill: "#e0e0e0"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 547.86,
    y: 424.02,
    width: 35.47,
    height: 118.64,
    transform: "translate(-35.84 -168.22) rotate(11.24)",
    fill: "#01bf71"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 606.43,
    y: 475.19,
    width: 35.47,
    height: 79.5,
    transform: "translate(-28.56 -179.03) rotate(11.24)",
    fill: "#3ad29f"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 665.23,
    y: 523.93,
    width: 35.47,
    height: 42.81,
    transform: "translate(-21.5 -189.92) rotate(11.24)",
    fill: "#f55f44"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 731.91,
    y: 492.72,
    width: 35.47,
    height: 86.84,
    transform: "translate(-22.02 -203.09) rotate(11.24)",
    fill: "#fdd835"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.65,
    y: 645.09,
    width: 3.67,
    height: 20.79,
    fill: "#47e6b1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.58,
    y: 712.31,
    width: 3.67,
    height: 20.79,
    transform: "translate(853.2 384.07) rotate(90)",
    fill: "#47e6b1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M699.44,75.56a4.49,4.49,0,0,1-2.5-5.43,2.16,2.16,0,0,0,.1-.5h0a2.25,2.25,0,0,0-4-1.49h0a2.16,2.16,0,0,0-.25.44,4.49,4.49,0,0,1-5.43,2.5,2.16,2.16,0,0,0-.5-.1h0a2.25,2.25,0,0,0-1.49,4h0a2.16,2.16,0,0,0,.44.25,4.49,4.49,0,0,1,2.5,5.43,2.16,2.16,0,0,0-.1.5h0a2.25,2.25,0,0,0,4,1.49h0a2.16,2.16,0,0,0,.25-.44,4.49,4.49,0,0,1,5.43-2.5,2.16,2.16,0,0,0,.5.1h0a2.25,2.25,0,0,0,1.49-4h0A2.16,2.16,0,0,0,699.44,75.56Z",
    transform: "translate(-140.93 -67.23)",
    fill: "#4d8af0",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M286.33,179.4a4.49,4.49,0,0,1-2.5-5.43,2.16,2.16,0,0,0,.1-.5h0a2.25,2.25,0,0,0-4-1.49h0a2.16,2.16,0,0,0-.25.44,4.49,4.49,0,0,1-5.43,2.5,2.16,2.16,0,0,0-.5-.1h0a2.25,2.25,0,0,0-1.49,4h0a2.16,2.16,0,0,0,.44.25,4.49,4.49,0,0,1,2.5,5.43,2.16,2.16,0,0,0-.1.5h0a2.25,2.25,0,0,0,4,1.49h0a2.16,2.16,0,0,0,.25-.44,4.49,4.49,0,0,1,5.43-2.5,2.16,2.16,0,0,0,.5.1h0a2.25,2.25,0,0,0,1.49-4h0A2.16,2.16,0,0,0,286.33,179.4Z",
    transform: "translate(-140.93 -67.23)",
    fill: "#fdd835",
    opacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M253.63,484.46a4.49,4.49,0,0,1-2.5-5.43,2.16,2.16,0,0,0,.1-.5h0a2.25,2.25,0,0,0-4-1.49h0a2.16,2.16,0,0,0-.25.44,4.49,4.49,0,0,1-5.43,2.5,2.16,2.16,0,0,0-.5-.1h0a2.25,2.25,0,0,0-1.49,4h0a2.16,2.16,0,0,0,.44.25,4.49,4.49,0,0,1,2.5,5.43,2.16,2.16,0,0,0-.1.5h0a2.25,2.25,0,0,0,4,1.49h0a2.16,2.16,0,0,0,.25-.44,4.49,4.49,0,0,1,5.43-2.5,2.16,2.16,0,0,0,.5.1h0a2.25,2.25,0,0,0,1.49-4h0A2.16,2.16,0,0,0,253.63,484.46Z",
    transform: "translate(-140.93 -67.23)",
    fill: "#fdd835",
    opacity: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 337.81,
    cy: 28.62,
    r: 7.34,
    fill: "#f55f44",
    opacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.34,
    cy: 317.46,
    r: 7.34,
    fill: "#f55f44",
    opacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 863.76,
    cy: 120.36,
    r: 7.34,
    fill: "#f55f44",
    opacity: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 822.17,
    cy: 339.3,
    r: 7.34,
    fill: "#4d8af0",
    opacity: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.68,
    cy: 145.22,
    r: 7.34,
    fill: "#47e6b1",
    opacity: 0.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 853.29,
    cy: 647.34,
    r: 7.34,
    fill: "#47e6b1",
    opacity: 0.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 910.8,
    cy: 430.97,
    r: 7.34,
    fill: "#47e6b1",
    opacity: 0.5
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 544.42,
    y: 601.05,
    width: 186.48,
    height: 153.07,
    fill: "url(#fd8d88e0-7826-450d-9e0b-001d1be709c2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M723.82,639a54.55,54.55,0,0,1,109.1,0v34.91h15.27V639a69.82,69.82,0,0,0-139.65,0v34.91h15.27Z",
    transform: "translate(-140.93 -67.23)",
    fill: "url(#8d1793c5-b76e-44e2-a52e-569460402331)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M726,638.25a52.37,52.37,0,1,1,104.74,0v33.52H845.4V638.25a67,67,0,0,0-134.06,0v33.52H726Z",
    transform: "translate(-140.93 -67.23)",
    fill: "#f5f5f5"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 546.32,
    y: 602.45,
    width: 182.24,
    height: 148.73,
    fill: "#01bf71"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 546.32,
    y: 602.45,
    width: 182.24,
    height: 148.73,
    fill: "#f5f5f5"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 546.32,
    y: 631.77,
    width: 182.24,
    height: 90.07,
    fill: "#01bf71"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M791.73,727a13.36,13.36,0,1,0-23.08,9.15v28.51a9.72,9.72,0,0,0,19.44,0V736.18A13.3,13.3,0,0,0,791.73,727Z",
    transform: "translate(-140.93 -67.23)",
    fill: "url(#4745700d-8097-45ff-9f71-625443fc4ad8)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M789.89,729.38a11.52,11.52,0,1,0-19.9,7.89v24.58a8.38,8.38,0,1,0,16.76,0V737.27A11.47,11.47,0,0,0,789.89,729.38Z",
    transform: "translate(-140.93 -67.23)",
    opacity: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg3);
export default __webpack_public_path__ + "static/media/svg-3.5394e075af4cfabca2aabdf649b7cbc6.svg";
export { ForwardRef as ReactComponent };